/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'goal-actions.goal-content-about.edit-description-error-description':
    'Der gik noget galt. Prøv igen om et par minutter.',
  'goal-content.goal-about-content.description-edit-button': 'Rediger',
  'goal-content.goal-about-content.description-title': 'Beskrivelse',
  'goal-content.goal-about-content.placeholder-description':
    'Beskriv kort, hvorfor dette mål er vigtigt, og hvad succeskriterierne er, så du kan give følgere en fælles forståelse.',
  'goal-content.goal-content-about.edit-description-error-title': 'Målbeskrivelsen kunne ikke redigeres',
  'goal-content.goal-content-update-date.edited': '(redigeret)',
  'goal-content.goal-content-update-date.edited-tooltip': 'Redigeret den {date}',
  'goal-content.goal-content-update-date.last-edited-by': '(senest redigeret af {name})',
  'goal-content.goal-content-updates.add-update': 'Tilføj opdatering',
  'goal-content.goal-content-updates.archived': 'Arkiveret',
  'goal-content.goal-content-updates.at-risk': 'I farezonen',
  'goal-content.goal-content-updates.cancelled': 'Annulleret',
  'goal-content.goal-content-updates.completed': 'Afsluttet 🎉',
  'goal-content.goal-content-updates.date-changed': 'Dato ændret',
  'goal-content.goal-content-updates.edit-update': 'Rediger',
  "goal-content.goal-content-updates.for-date'": 'til {dueDate}',
  'goal-content.goal-content-updates.latest-update-title': 'Seneste opdatering',
  'goal-content.goal-content-updates.missed-update-message': 'Der blev ikke slået nogen opdatering op',
  'goal-content.goal-content-updates.new-due-date': 'Ny deadline',
  'goal-content.goal-content-updates.new-state': 'Ny status',
  'goal-content.goal-content-updates.no-updates-description': 'Der er endnu ingen opdateringer til dette mål.',
  'goal-content.goal-content-updates.off-track': 'På vildspor',
  'goal-content.goal-content-updates.old-due-date': 'Gammel deadline',
  'goal-content.goal-content-updates.old-state': 'Gammel status',
  'goal-content.goal-content-updates.on-track': 'På ret kurs',
  'goal-content.goal-content-updates.paused': 'Sat på pause',
  'goal-content.goal-content-updates.pending': 'Afventer',
  'goal-content.goal-content-updates.previous-updates-title': 'Tidligere opdateringer',
  'goal-content.goal-content-updates.share-update': 'Del',
  'goal-content.goal-content-updates.status-changed': 'Status ændret',
  'goal-content.goal-content-updates.write-update-button': 'Skriv en opdatering',
  'goal-content.goal-update-composer.modal-title': 'Lav et opslag med din opdatering',
  'goal-content.goal-update-composer.post-button-label': 'Udgiv opdatering',
};
